import styled from "styled-components";

export const DeclineReasonsStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 6px;

  .hbar-row {
    display: grid;
    grid-template-columns: 180px 1fr 60px;
    align-items: center;
    gap: 10px;
    font-size: 12px;
  }

  .hbar-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .hbar-track {
    height: 8px;
    background: ${({ theme }) => theme.colors.accent[50]};
    border-radius: 999px;
    overflow: hidden;
    position: relative;
  }

  .hbar-fill {
    height: 100%;
    background: linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.accent[400]},
      ${({ theme }) => theme.colors.accent[500]}
    );
    border-radius: 999px;
    transition: width 0.35s ease;
  }

  .hbar-value {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    text-align: right;
    font-variant-numeric: tabular-nums;
  }
`;
